import { render, staticRenderFns } from "./Viewteacherreport.vue?vue&type=template&id=3354a040&scoped=true&"
import script from "./Viewteacherreport.vue?vue&type=script&lang=js&"
export * from "./Viewteacherreport.vue?vue&type=script&lang=js&"
import style0 from "./Viewteacherreport.vue?vue&type=style&index=0&id=3354a040&scoped=true&lang=css&"
import style1 from "./Viewteacherreport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3354a040",
  null
  
)

export default component.exports